export function isDisallowedForCompositeWorks(card: any): boolean {
    return (
        card?.canBeUsedInCompositeWorks === false ||
        card?.CanBeUsedInCompositeWorks === false
    );
}

export function isCardBlockedForPaidBook(card: any): boolean {
    return card?.printQuality === "A5" || isDisallowedForCompositeWorks(card);
}
export function isDisallowedForCompositeWorks(card: any): boolean {
    return (
        card?.canBeUsedInCompositeWorks === false ||
        card?.CanBeUsedInCompositeWorks === false
    );
}

export function isCardBlockedForPaidBook(card: any): boolean {
    return card?.printQuality === "A5" || isDisallowedForCompositeWorks(card);
}
